import React, { FC, useEffect, useState } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { AppProps } from './app.props';
import styles from './app.module.scss';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import { useAppStore } from '../../app.context';
import { BuilderPage } from '../builder-page/builder-page';



/**
 * <App />
 */
const App: FC<AppProps> = observer(() => {
  const {
    general: { setHistory }
  } = useAppStore();

  const location = useLocation();

  const navigate = useNavigate();

  useEffect(() => {
    //@ts-ignore
    setHistory(navigate);
  }, [location, navigate]);

  return <div className={classNames(styles.app)}>
    <Routes>
          <Route path='/' Component={BuilderPage} />
         
          <Route path='*' Component={BuilderPage} />
        </Routes>
  </div>;
});

export { App };
